import { useEffect, useRef, useState } from "react";
import axiosInstance from "../axios";
import urls from "../Utils/urls";

export const useLoanForeClosureStatus = (accountID) => {
  const [maturedLoanData, setMaturedLoanData] = useState([]);
  const [loadingLoanStatus, setLoadingLoanStatus] = useState(false);
  const [maturedStatus, setMaturedStatus] = useState(null);
  const prevAccountIDRef = useRef(); // Reference to store the previous accountID

  useEffect(() => {
    const accountIDString = Array.isArray(accountID)
      ? accountID.join(" ")
      : accountID;

    // Only fetch data if the accountID has changed
    if (prevAccountIDRef.current !== accountIDString) {
      prevAccountIDRef.current = accountIDString;

      const fetchForeClosureFlag = async () => {
        setLoadingLoanStatus(true);
        setMaturedLoanData([]); // Reset maturedLoanData to ensure fresh state for new account
        setMaturedStatus(null); // Reset maturedStatus to null before fetching new data
        try {
          const loanID = accountIDString;

          const payload = {
            loanID: loanID, // Use the joined string or single accountID
          };
          const res = await axiosInstance.post(
            urls.tools.getForeclosureFlag,
            payload,
          );
          const data = res?.data?.[0]; // Assuming the response is an array and we want the first item

          // Ensure `data` exists and then set the flag and other loan data
          if (data) {
            const flag = data?.[0]?.Flag; // Extract the flag directly from the response
            setMaturedStatus(flag); // Update the maturity status
            setMaturedLoanData(data); // Store the fetched loan data
          } else {
            // Handle case where no data is returned (optional)
            setMaturedStatus(null);
            setMaturedLoanData([]);
          }
        } catch (error) {
          console.error("Error fetching maturity flag:", error);
          setMaturedLoanData([]);
          setMaturedStatus(null);
        } finally {
          setLoadingLoanStatus(false); // Reset loading state
        }
      };

      fetchForeClosureFlag(); // Call the async function to fetch data
    }
  }, [accountID]); // Effect runs whenever accountID changes

  return {
    foreClosureLoanData: maturedLoanData,
    loadingLoanStatus,
    foreClosureStatus: maturedStatus,
  };
};
